<template>
  <base-dialog @cancel="cancelDialog" :width="1000">
    <div slot="header">{{$t('common_224')}}</div>
    <div slot="body">
      <dialog-table v-if="loaded" :data="recordList" :columns="columns" :showOverflow="true" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="cancelDialog">{{ $t('dialog.ok') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { numerify } from '@/filters'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { currencyUnitMap } from '@/constants/currency'
import { getUsedHoursColumn } from '../utils/columns'

export default {
  name: 'CppSharedDetailDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      loaded: false,
      columns: [
        {
          type: 'seq',
          width: 60,
          title: this.$t('bill.sort_number'),
        },
        {
          field: 'project',
          title: this.$t('bill.project'),
          sshowOverflow: 'ellipsis',
          formatter: ({ row }) => {
            const matchProject = this.projectsList.filter(item => item.id === row.tenant_id)
            return matchProject[0] ? matchProject[0].name : row.tenant_id
          },
        },
        {
          field: 'assigned',
          width: 100,
          title: this.$t('bill.assigned_number'),
          formatter: ({ row }) => {
            return row.cpp_count
          },
        },
        {
          field: 'amount_hours',
          title: this.$t('bill.amount_hours'),
          formatter: ({ row }) => {
            return `${numerify(row.cpp_total_hours, '0.00')} h`
          },
        },
        getUsedHoursColumn(),
        {
          field: 'cpp_cost',
          title: this.$t('bill.cpp_cost'),
          formatter: ({ row }) => {
            const { currency = 'CNY', cpp_cost = 0 } = row
            const sign = currencyUnitMap[currency].sign
            return `${sign} ${numerify(cpp_cost, '0,0.00')}`
          },
        },
        {
          field: 'postpaid_cost',
          title: this.$t('bill.on_demand_cost'),
          formatter: ({ row }) => {
            const { currency = 'CNY', postpaid_cost = 0 } = row
            const sign = currencyUnitMap[currency].sign
            return `${sign} ${numerify(postpaid_cost, '0,0.00')}`
          },
        },
      ],
      projectsList: [],
    }
  },
  computed: {
    recordList () {
      const data = this.params.data[0] || {}
      const { shard_details = [] } = data
      return shard_details
    },
  },
  created () {
    this.$p = new this.$Manager('projects', 'v1')
    this.fetchProjects()
  },
  methods: {
    async fetchProjects () {
      const ids = this.recordList.map(item => item.tenant_id)
      if (!ids.length) {
        this.loaded = true
        return
      }
      try {
        const { data = {} } = await this.$p.list({
          params: {
            filter: `id.contains(${ids})`,
            scope: this.$store.getters.scope,
          },
        })
        this.projectsList = data.data
      } catch (err) {

      } finally {
        this.loaded = true
      }
    },
  },
}
</script>
